import * as Icons from "lucide-react";
import { LucideProps, Circle } from "lucide-react";

/** Curated subset of Lucide icons available to the menu admin. */
export const NAV_ICON_OPTIONS = [
  "Heart", "Wallet", "Users", "UserCircle", "MessageCircle",
  "Search", "LayoutDashboard", "CreditCard", "Settings", "Building2",
  "HelpCircle", "Briefcase", "Home", "FileText", "Bell",
  "Star", "Calendar", "Mail", "Phone", "Shield",
  "Crown", "Sparkles", "Tag", "BarChart3", "User",
  "ShoppingBag", "BookOpen", "Globe", "Compass", "Map",
  "Circle", "Square", "Bookmark", "Gift", "Zap",
] as const;

interface NavIconProps extends LucideProps {
  name: string;
}

/** Render a Lucide icon by name, falling back to Circle for unknowns. */
export function NavIcon({ name, ...props }: NavIconProps) {
  const Icon = ((Icons as unknown) as Record<string, React.ComponentType<LucideProps>>)[name] ?? Circle;
  return <Icon {...props} />;
}
